import React from "react";
import {
  render,
  MARK_SUBSCRIPT,
  MARK_SUPERSCRIPT,
} from "storyblok-rich-text-react-renderer";
import classNames from "classnames";
import { useTemplateTranslation } from "@app/hooks";

type Props = {
  content: string;
};

export const EventDetails: React.FC<Props> = ({ content }) => {
  const { t } = useTemplateTranslation();
  const parsedContent = JSON.parse(content);
  const {
    details,
    language: mainLanguage,
    location: place,
    mapsLink,
  } = parsedContent;

  return (
    <div
      className={classNames(
        "mb-20 px-5",
        "lg:mb-25 lg:px-15",
        "xxl:mb-40 xxl:px-24",
      )}
    >
      <div
        className={classNames(
          "rounded-lg bg-dark px-9 py-15 text-regular text-primary-content",
          "lg:p-15",
          "xxl:p-30",
        )}
      >
        <h2
          className={classNames(
            "mb-5 text-medium",
            "lg:mb-10 lg:text-large",
            "xxl:mb-15 xxl:text-extra-large",
          )}
        >
          {t("details_title")}
        </h2>
        <div
          className={classNames(
            "flex flex-col",
            "lg:flex-row lg:gap-15",
            "xl:justify-between xl:gap-0",
          )}
        >
          <div
            className={classNames(
              "mb-5 flex-1",
              "lg:mb-0",
              "xl:w-2/5 xl:flex-none",
            )}
          >
            <p className="text-base-400">{t("details_location_label")}</p>
            <div className="mb-5">
              {render(place, {
                markResolvers: {
                  [MARK_SUBSCRIPT]: (children) => <sub>{children}</sub>,
                  [MARK_SUPERSCRIPT]: (children) => <sup>{children}</sup>,
                },
              })}
            </div>
            {mapsLink?.url.length && <a href={mapsLink.url}>Google Maps</a>}
            <p className="mt-5 text-base-400">{t("details_language_label")}</p>
            <p>{mainLanguage}</p>
          </div>
          <div className={classNames("flex-1", "xl:w-1/2 xl:flex-none")}>
            <p className="text-base-400">{t("details_programm_label")}</p>
            {details.map((item, index) => (
              <div
                key={item._uid}
                className={classNames({ "mb-5": index !== details.length - 1 })}
              >
                <p>{item.title}</p>
                {item.details && (
                  <div className="mt-5">
                    {render(item.details, {
                      markResolvers: {
                        [MARK_SUBSCRIPT]: (children) => <sub>{children}</sub>,
                        [MARK_SUPERSCRIPT]: (children) => <sup>{children}</sup>,
                      },
                    })}
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};
